import { jsx as _jsx } from "react/jsx-runtime";
import { RouteNaming, Z3kRoutes, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { useCallback } from 'react';
import { Z3kDragDropList } from '../../../../utils/drag-drop-list/drag-drop-list';
export function NewRadioSensors433ClickList(props) {
    const parentUrlRadiosensors = useCallback(() => Z3kRoutes.radiosensors, []);
    return (_jsx(Z3kDragDropList, { z3k_name: "radiosensors433", name: RouteNaming[Z3kSecondRoutes.radiosensor433], help_id: props.help_id ?? 'radiosensors433', item_url: Z3kSecondRoutes.radiosensor433, parentUrl: parentUrlRadiosensors, hideAddButton: true, enableDnd: true, mainTitleComponentRender: props.mainTitleComponentRender }));
}
